import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useDocumentsRouteStyles = () => {
  const { theme } = useTheme();

  const unreadDot: CSSProperties = {
    width: 8,
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.documents.unread,
    marginLeft: spacing.xs,
    flexShrink: 0,
  };

  return { unreadDot };
};
